<template>
  <div class="home">
    <section class="welcome">
      <div>
        <h1
          class="main-heading"
        >Hi, I'm Jack. I am an apprentice trained, .NET developer based in Ipswich UK.</h1>
      </div>
      <terminal class="home-terminal" />
    </section>
    <TileRepeater :tile-items="tileData" />
  </div>
</template>

<script>
import terminal from '@/components/widgets/terminal.vue'
import TileRepeater from '@/components/navigation/tile-repeater.vue'

export default {
  name: 'home',
  components: {
    terminal,
    TileRepeater
  },
  data () {
    return {
      tileData: [
        {
          title: 'Blog',
          previewText: 'Technical articles and opinion peices.',
          routeName: 'blog',
          previewImageSrc: require(`@/assets/blogging.jpg`),
          previewImageAlt: 'Blog',
          id: 1
        },
        {
          title: 'My Skills',
          routeName: 'myskills',
          previewText: 'A little about what I can do.',
          previewImageSrc: require(`@/assets/front-end-development.jpg`),
          previewImageAlt: 'front end development',
          id: 2
        },
        {
          title: 'This Site',
          routeName: 'thissite',
          previewText: 'The motivations around creating this site.',
          previewImageSrc: require(`@/assets/camera-coffee-composition.jpg`),
          previewImageAlt: 'this site',
          id: 3
        },
        {
          title: 'About Me',
          previewText: 'A little about my background as a developer.',
          routeName: 'about',
          previewImageSrc: require(`@/assets/JackBitmojiComputer.png`),
          previewImageAlt: 'Jack typing',
          id: 4
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  column-gap: 16px;
  margin-bottom: 20px;
  @media screen and (max-width: 650px) {
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 762px) {
  .home-terminal {
    display: none;
  }
}

</style>
